import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.knowledge_map');
import { OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-knowledge_map',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.knowledge_map/view.scss */
:host {
  display: block;
  min-height: calc(100dvh - var(--workspace-header-height, 64px));
  background: var(--ui-canvas);
}

.map-content {
  --map-ink:var(--ui-ink);
  --map-muted:var(--ui-muted);
  --map-line:var(--ui-line);
  --map-blue:var(--ui-accent);
  color: var(--map-ink);
  font-size: 13px;
  font-weight: 400;
  max-width: 1680px;
  margin: auto;
  padding: 16px var(--workspace-gutter, 16px) 24px;
}

.map-content *, .map-content *::before, .map-content *::after {
  box-sizing: border-box;
}

.map-content ::selection {
  background: var(--ui-selected);
  color: var(--ui-ink);
}

button, input, select {
  font: inherit;
}

button, a, input, select, summary {
  -webkit-tap-highlight-color: transparent;
}

button:focus-visible, a:focus-visible, input:focus-visible, select:focus-visible, summary:focus-visible {
  outline: 2px solid var(--map-blue);
  outline-offset: 3px;
}

button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.button {
  min-height: 36px;
  padding: 7px 12px;
  font-size: 13px;
  font-weight: 650;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  background: var(--ui-paper);
  border: 1px solid var(--map-line);
  border-radius: 8px;
  color: var(--ui-text);
  cursor: pointer;
}

.icon-button:hover:not(:disabled) {
  background: var(--ui-selected);
  color: var(--map-blue);
}

.text-button, .text-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--ui-accent);
  font-weight: 650;
  font-size: 13px;
  background: transparent;
  border: 0;
  padding: 6px 2px;
  min-height: 36px;
  cursor: pointer;
  text-decoration: none;
}

.text-button:hover, .text-link:hover {
  text-decoration: underline;
  text-underline-offset: 4px;
}

.map-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 12px;
}

.heading-title {
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
}

.exploration-controls {
  background: var(--ui-paper);
  border: 0;
  border-radius: var(--ui-radius) var(--ui-radius) 0 0;
  padding: 16px;
  margin-bottom: 0;
}

.map-heading > .button {
  text-decoration: none;
}

.map-heading h1 {
  font-size: 22px;
  line-height: 1.3;
  letter-spacing: -0.025em;
  font-weight: 750;
  margin: 0;
}

.campaign-info {
  position: relative;
  font-size: 13px;
}

.campaign-info summary {
  min-height: 36px;
  cursor: pointer;
  color: var(--ui-muted);
  padding: 6px 0;
  font-weight: 600;
}

.campaign-info p {
  position: absolute;
  top: 100%;
  left: 0;
  width: 340px;
  max-width: calc(100vw - 48px);
  background: var(--ui-paper);
  border: 1px solid var(--map-line);
  padding: 16px;
  margin: 0;
  z-index: 5;
  line-height: 1.7;
  color: var(--map-muted);
}

.search-toolbar {
  display: flex;
  gap: 10px;
  width: 100%;
  align-items: center;
}

.search-input {
  display: flex;
  flex: 1;
  position: relative;
  align-items: center;
  min-width: 0;
}

.search-input i {
  position: absolute;
  left: 15px;
  color: var(--map-muted);
}

.search-input input {
  width: 100%;
  min-height: 36px;
  border: 1px solid var(--ui-control);
  border-radius: 8px;
  background: var(--ui-paper);
  padding: 7px 12px 7px 38px;
  color: var(--map-ink);
  caret-color: var(--map-blue);
  font-size: 13px;
}

.search-input input::placeholder {
  color: var(--ui-muted);
  opacity: 1;
}

.search-toolbar .button, .refresh-button {
  height: 36px;
}

.map-filters {
  display: grid;
  grid-template-columns: 1fr 1fr 1.4fr 0.8fr;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid var(--map-line);
}

.map-filters label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  font-size: 13px;
  font-weight: 650;
}

select {
  appearance: auto;
  -webkit-appearance: auto;
  background: var(--ui-paper);
  background-image: none;
  border: 1px solid var(--ui-control);
  border-radius: 8px;
  color: var(--map-ink);
  padding: 7px 28px 7px 10px;
  min-height: 36px;
  max-width: 100%;
  font-size: 13px;
}

.scope-bar {
  display: flex;
  gap: 8px 16px;
  flex-wrap: wrap;
  align-items: center;
  min-height: 32px;
  padding-top: 8px;
  color: var(--map-muted);
  font-size: 14px;
}

.scope-bar .review-scope {
  font-weight: 650;
}

.scope-bar .text-button {
  margin-left: auto;
  font-size: 14px;
}

.concept-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  border: 0;
  border-top: 1px solid var(--map-line);
  border-radius: 0;
  padding: 6px 16px;
  background: var(--ui-paper);
}

.compact-concept-type, .compact-concept-source {
  display: none;
}

.concept-browser {
  position: relative;
  min-width: 0;
  flex: 1;
}

.concept-trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 4px;
  min-height: 36px;
  color: var(--map-ink);
  background: none;
  border: 0;
  cursor: pointer;
  max-width: 100%;
}

.concept-trigger > span {
  font-size: 13px;
  color: var(--map-muted);
  white-space: nowrap;
}

.concept-trigger strong {
  font-size: 15px;
  font-weight: 700;
  color: var(--map-blue);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.concept-trigger i {
  font-size: 12px;
  color: var(--map-blue);
}

.concept-options {
  position: absolute;
  z-index: 8;
  width: 420px;
  max-width: calc(100vw - 68px);
  left: 0;
  top: calc(100% + 8px);
  background: var(--ui-paper);
  border: 0;
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(35, 39, 47, 0.1490196078);
  overflow: hidden;
}

.concept-options header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 16px;
}

.concept-options header span {
  color: var(--map-blue);
  margin-left: 4px;
}

.concept-options > p {
  font-size: 14px;
  color: var(--map-muted);
  line-height: 1.6;
  margin: 0;
  padding: 0 12px 8px;
}

.concept-options-list {
  max-height: min(380px, 45dvh);
  overflow: auto;
  border-top: 1px solid var(--map-line);
}

.concept-option {
  width: 100%;
  text-align: left;
  border: 0;
  border-bottom: 1px solid var(--map-line);
  background: var(--ui-paper);
  padding: 12px 16px;
  color: var(--map-ink);
  cursor: pointer;
}

.concept-option:hover, .concept-option.active {
  background: var(--ui-selected);
}

.concept-option > span {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.concept-option strong {
  font-size: 15px;
}

.concept-option small {
  display: block;
  margin-top: 4px;
  font-size: 14px;
  color: var(--map-muted);
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.concept-option .option-job {
  font-size: 13px;
}

.result-boundary {
  font-size: 13px;
  color: var(--map-muted);
  flex-shrink: 0;
  margin: 0;
}

.result-boundary strong {
  color: var(--ui-text);
  font-weight: 650;
}

.explorer {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  gap: 0;
  border: 0;
  border-top: 1px solid var(--map-line);
  border-radius: 0 0 var(--ui-radius) var(--ui-radius);
  overflow: hidden;
  align-items: stretch;
}

.explorer.inspecting {
  grid-template-columns: minmax(0, 1fr) 360px;
}

.map-stage {
  min-width: 0;
  background: var(--ui-soft);
}

.focus-heading {
  padding: 14px 18px;
  background: var(--ui-paper);
}

.focus-heading > div {
  display: flex;
  gap: 12px;
  align-items: center;
}

.focus-heading .concept-type {
  padding: 2px 7px;
  border: 1px solid currentColor;
  border-radius: 4px;
  font-size: 13px;
  white-space: nowrap;
}

.concept-type {
  font-size: 14px;
  font-weight: 700;
}

.focus-heading h2 {
  font-size: 22px;
  line-height: 1.4;
  font-weight: 750;
  letter-spacing: -0.025em;
  margin: 4px 0;
  overflow-wrap: anywhere;
}

.focus-heading p {
  font-size: 13px;
  color: var(--map-muted);
  line-height: 1.5;
  margin: 0;
  overflow-wrap: anywhere;
}

.diagram-disclosure > summary {
  display: none;
}

.diagram-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 18px 0;
  color: var(--map-muted);
  font-size: 13px;
}

.zoom-tools {
  display: flex;
  align-items: center;
  gap: 4px;
  font-variant-numeric: tabular-nums;
}

.zoom-tools .text-button {
  min-width: 56px;
  justify-content: center;
}

.zoom-tools .icon-button {
  width: 36px;
  height: 36px;
  background: transparent;
  border: 0;
}

.diagram-scroll {
  overflow: auto;
  scrollbar-color: var(--ui-control) var(--ui-soft);
}

.network {
  display: block;
  width: 100%;
  height: 460px;
  touch-action: none;
  cursor: grab;
}

.network:active {
  cursor: grabbing;
}

.edge-hit {
  stroke: transparent;
  stroke-width: 20px;
  fill: none;
}

.graph-edge {
  cursor: pointer;
  outline: none;
}

.edge-line {
  fill: none;
  stroke: #7a9080;
  stroke-width: 1.8;
}

.edge-label-bg {
  fill: var(--ui-soft);
}

.edge-label {
  fill: var(--ui-text);
  font-size: 17px;
  font-weight: 650;
}

.graph-edge.uncertain .edge-line {
  stroke-dasharray: 7 5;
}

.graph-edge.negative .edge-line {
  stroke: var(--ui-danger);
  stroke-dasharray: 2 4;
}

.graph-edge.negative .edge-label {
  fill: var(--ui-danger);
}

.graph-edge.chosen .edge-line, .graph-edge:hover .edge-line, .graph-edge:focus-visible .edge-line {
  stroke: var(--map-blue);
  stroke-width: 3;
}

.graph-edge:focus-visible .edge-label-bg {
  stroke: var(--map-blue);
  stroke-width: 2;
}

.graph-node {
  cursor: pointer;
  outline: none;
}

.graph-node rect {
  stroke-width: 1;
}

.graph-node:hover rect, .graph-node:focus-visible rect {
  stroke: var(--map-blue);
  stroke-width: 3;
}

.graph-node.center-node {
  cursor: default;
}

.graph-node.center-node rect {
  stroke-width: 2;
}

.node-type {
  font-size: 15px;
  font-weight: 650;
  pointer-events: none;
}

.node-name {
  font-size: 19px;
  font-weight: 700;
  fill: var(--ui-ink);
  pointer-events: none;
}

.diagram-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 4px 18px;
  border-top: 0;
  font-size: 13px;
  color: var(--map-muted);
  font-variant-numeric: tabular-nums;
}

.diagram-footer > div {
  display: flex;
  align-items: center;
  gap: 12px;
}

.diagram-footer .icon-button {
  border: 0;
  background: transparent;
}

.map-footnote {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 8px;
  font-size: 13px;
  color: var(--map-muted);
  line-height: 1.7;
  margin: 0;
  padding: 8px 18px 12px;
  border-top: 0;
}

.legend-line {
  width: 16px;
  border-top: 2px solid #637d6b;
  margin-left: 8px;
}

.legend-line.conditional {
  border-top-style: dashed;
}

.legend-line.negative {
  border-top: 2px dotted var(--ui-danger);
}

.relation-direction {
  color: var(--ui-muted);
  margin-right: 4px;
}

.detail-pane {
  min-width: 0;
  border-left: 1px solid var(--map-line);
  background: var(--ui-paper);
  max-height: min(720px, 100dvh - var(--workspace-header-height, 0px) - 48px);
  overflow: auto;
  scroll-padding-block: 64px 16px;
  scrollbar-color: var(--ui-control) var(--ui-soft);
}

.relations-heading {
  padding: 14px 16px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  position: sticky;
  top: 0;
  background: var(--ui-paper);
  z-index: 1;
}

.relations-heading h2 {
  font-size: 16px;
  font-weight: 750;
  margin: 0;
}

.relations-heading h2 span {
  color: var(--map-blue);
  margin-left: 5px;
}

.relation-filter select {
  max-width: 135px;
  font-size: 13px;
}

.panel-hint {
  margin: 0;
  padding: 0 16px 12px;
  font-size: 13px;
  color: var(--map-muted);
  border-bottom: 1px solid var(--map-line);
}

.relationship-row {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  background: var(--ui-paper);
  border: 0;
  border-bottom: 1px solid transparent;
  text-align: left;
  color: var(--map-ink);
  padding: 12px 16px;
  cursor: pointer;
  line-height: 1.6;
}

.relationship-row:hover, .relationship-row.chosen {
  background: var(--ui-selected);
}

.relationship-row strong {
  font-size: 15px;
  font-weight: 700;
  overflow-wrap: anywhere;
}

.relationship-row strong i {
  font-size: 12px;
  color: var(--map-muted);
  padding: 0 4px;
}

.relation-label {
  display: flex;
  flex-wrap: wrap;
  gap: 5px 12px;
  font-size: 13px;
  font-weight: 550;
  color: var(--ui-muted);
}

.relation-label > span {
  color: var(--ui-muted);
  font-weight: 500;
}

.relation-label > .negative-text {
  color: var(--ui-danger);
}

.relation-source {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: var(--map-muted);
  overflow-wrap: anywhere;
}

.no-connections {
  padding: 20px;
  color: var(--map-muted);
  font-size: 16px;
  line-height: 1.7;
}

.evidence-panel {
  outline: none;
  scroll-margin-top: calc(var(--workspace-header-height, 64px) + 24px);
}

.evidence-panel:focus-visible {
  outline: 2px solid var(--map-blue);
  outline-offset: -2px;
}

.evidence-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  position: sticky;
  top: 0;
  background: var(--ui-paper);
  padding: 6px 14px;
  border-bottom: 1px solid var(--map-line);
  z-index: 2;
}

.evidence-toolbar > span {
  font-size: 14px;
  color: var(--map-muted);
}

.claim-summary {
  padding: 18px;
}

.claim-summary h2 {
  font-size: 20px;
  font-weight: 750;
  line-height: 1.5;
  letter-spacing: -0.02em;
  margin: 8px 0;
  overflow-wrap: anywhere;
}

.assertion-label {
  color: var(--map-muted);
  font-size: 14px;
  margin: 0;
}

.qualifiers {
  font-size: 15px;
  line-height: 1.75;
  color: var(--ui-text);
  margin: 14px 0 0;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.evidence {
  margin: 0 18px;
  padding: 18px 0;
  border-top: 1px solid var(--map-line);
}

.evidence h3 {
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 6px;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.evidence header p {
  font-size: 13px;
  color: var(--map-muted);
  margin: 0 0 14px;
}

.evidence blockquote {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.8;
  padding: 14px;
  margin: 0 0 14px;
  border: 0;
  background: var(--ui-soft);
  color: var(--map-ink);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  max-height: none;
  overflow: visible;
}

.evidence a, .review-link {
  font-size: 13px;
  line-height: 1.7;
  color: var(--ui-accent);
  text-underline-offset: 4px;
  font-weight: 650;
}

.review-link {
  display: block;
  margin: 0 14px 14px;
  padding-top: 12px;
  border-top: 1px solid var(--map-line);
}

.query-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 0;
}

.query-footer p {
  font-size: 13px;
  color: var(--map-muted);
  line-height: 1.6;
  margin: 0;
}

.query-footer > div {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  font-variant-numeric: tabular-nums;
}

.query-footer .button {
  font-size: 14px;
  padding: 8px 12px;
}

.empty {
  padding: 36px 20px;
  text-align: center;
  color: var(--map-muted);
}

.empty h2 {
  font-size: 20px;
  font-weight: 700;
  color: var(--map-ink);
  margin: 0 0 12px;
  word-break: keep-all;
}

.empty p {
  font-size: 14px;
  line-height: 1.7;
  margin: 0 0 22px;
  word-break: keep-all;
}

.state-message, .loading-workspace {
  padding: 36px 20px;
  color: var(--map-muted);
  font-size: 16px;
}

.loading-workspace {
  min-height: 560px;
  background: var(--ui-soft);
}

.loading-lines {
  margin-top: 30px;
  width: 100%;
  height: 240px;
  border-block: 1px solid var(--map-line);
  background: var(--ui-soft);
}

.error-message {
  margin: 12px 0;
  padding: 14px 18px;
  color: var(--ui-danger);
  border: 1px solid #e9c5c5;
  background: #fff4f3;
  font-size: 16px;
  line-height: 1.7;
}

@media (max-width: 1249px) {
  .explorer, .explorer.inspecting {
    grid-template-columns: minmax(0, 1fr);
  }
  .detail-pane {
    border-left: 0;
    border-top: 1px solid var(--map-line);
    max-height: none;
    overflow: visible;
  }
  .diagram-disclosure > summary {
    display: list-item;
    padding: 14px 24px;
    cursor: pointer;
    color: var(--ui-accent);
    font-size: 16px;
    font-weight: 650;
    border-top: 1px solid var(--map-line);
  }
  .diagram-disclosure > summary span {
    font-size: 14px;
    font-weight: 500;
    color: var(--map-muted);
    margin-left: 12px;
  }
  .network {
    min-width: 820px;
    height: 500px;
  }
  .map-footnote {
    display: none;
  }
  .relationship-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    max-height: 620px;
    overflow: auto;
    scrollbar-color: var(--ui-control) var(--ui-soft);
  }
  .relationship-row:nth-child(odd) {
    border-right: 1px solid var(--map-line);
  }
  .evidence-panel {
    max-width: 900px;
    margin-inline: auto;
  }
  .evidence-toolbar {
    top: var(--workspace-header-height, 64px);
  }
  .evidence blockquote {
    max-width: 75ch;
  }
  .query-footer {
    align-items: flex-start;
  }
  .map-filters {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .map-content {
    padding: 12px var(--workspace-gutter, 12px) 20px;
  }
  .map-heading {
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 16px;
  }
  .map-heading > .button {
    font-size: 14px;
    padding-inline: 12px;
  }
  .exploration-controls {
    padding: 12px;
  }
  .concept-bar {
    padding: 8px 12px;
  }
  .concept-trigger {
    gap: 8px;
    padding: 4px 0;
  }
  .concept-trigger strong {
    font-size: 20px;
    line-height: 1.4;
    white-space: normal;
    text-align: left;
    overflow-wrap: anywhere;
  }
  .compact-concept-type {
    display: inline-block;
    margin-top: 4px;
    font-size: 12px;
  }
  .compact-concept-source {
    display: block;
    margin: 0;
    color: var(--map-muted);
    font-size: 13px;
    line-height: 1.5;
    overflow-wrap: anywhere;
  }
  .focus-heading {
    display: none;
  }
  .concept-trigger > span {
    display: none;
  }
  .concept-browser {
    flex-basis: 100%;
  }
  .concept-options {
    max-width: calc(100vw - 60px);
  }
  .focus-heading > div {
    align-items: flex-start;
    flex-direction: column;
    gap: 4px;
  }
  .explorer.inspecting .map-stage {
    display: none;
  }
  .heading-title {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
  }
  .map-heading h1 {
    font-size: 20px;
  }
  .map-heading > .text-link {
    font-size: 13px;
  }
  .campaign-info summary {
    padding: 4px 0;
    font-size: 13px;
  }
  .campaign-info p {
    left: 0;
  }
  .search-toolbar {
    flex-wrap: wrap;
    gap: 8px;
  }
  .search-input {
    flex-basis: calc(100% - 80px);
  }
  .search-input input {
    font-size: 16px;
  }
  .search-toolbar .button {
    padding: 9px 12px;
  }
  .search-toolbar .button.secondary {
    font-size: 14px;
    height: 44px;
  }
  .refresh-button {
    margin-left: auto;
    height: 44px;
  }
  .scope-bar {
    font-size: 13px;
    min-height: 40px;
  }
  .concept-bar {
    flex-wrap: wrap;
    padding: 12px 0;
    gap: 8px;
  }
  .concept-bar > label {
    gap: 8px;
    font-size: 14px;
    min-width: 230px;
  }
  .concept-bar select {
    font-size: 16px;
    flex: 1;
    width: 0;
  }
  .result-boundary {
    width: 100%;
    font-size: 13px;
  }
  .focus-heading {
    padding: 12px;
  }
  .focus-heading h2 {
    font-size: 20px;
  }
  .focus-heading p {
    font-size: 13px;
  }
  .diagram-disclosure > summary {
    padding: 14px 16px;
  }
  .diagram-disclosure > summary span {
    display: block;
    margin: 4px 0 0;
  }
  .diagram-toolbar {
    padding: 8px 12px;
    flex-wrap: wrap;
  }
  .diagram-toolbar > span {
    font-size: 13px;
  }
  .zoom-tools {
    margin-left: auto;
  }
  .diagram-footer {
    flex-wrap: wrap;
    padding: 8px 16px;
  }
  .diagram-footer > div {
    margin-left: auto;
  }
  .relationship-list {
    display: block;
  }
  .relationship-row:nth-child(odd) {
    border-right: 0;
  }
  .relations-heading {
    padding: 16px 16px 8px;
  }
  .panel-hint {
    padding: 0 16px 14px;
  }
  .relationship-row {
    padding: 16px;
  }
  .evidence-toolbar {
    position: static;
    padding-inline: 16px;
  }
  .claim-summary {
    padding: 18px 16px;
  }
  .evidence {
    margin-inline: 16px;
  }
  .review-link {
    margin-inline: 16px;
  }
  .query-footer {
    flex-direction: column;
    align-items: stretch;
  }
  .query-footer > div {
    justify-content: flex-end;
  }
  .empty {
    padding: 50px 8px;
  }
  .empty h2 {
    font-size: 20px;
  }
  .map-filters {
    grid-template-columns: 1fr;
    gap: 12px;
  }
}
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    transition: none !important;
  }
}
.map-content {
  font-family: Pretendard, "Noto Sans KR", sans-serif;
}

.button {
  font-size: 13px;
  border-radius: 8px;
}

.campaign-info summary {
  color: var(--ui-muted);
}

.scope-bar {
  padding-top: 6px;
  font-size: 13px;
}

.scope-bar .review-scope {
  color: var(--ui-text);
}

.focus-heading {
  border-bottom: 0;
}

.detail-pane, .relations-heading, .evidence-toolbar {
  background: var(--ui-paper);
}

.relations-heading {
  flex-wrap: wrap;
}

.relation-filter {
  margin-left: auto;
}

.evidence blockquote {
  border-radius: 8px;
}

.claim-summary {
  background: var(--ui-paper);
  border-bottom: 0;
}

.empty, .loading-workspace {
  border: 0;
  border-radius: var(--ui-radius);
  background: var(--ui-paper);
}

.error-message {
  border-radius: 8px;
}

@media (max-width: 760px) {
  .map-content {
    padding: 12px var(--workspace-gutter, 12px) 20px;
  }
  .exploration-controls {
    padding: 10px;
    margin-bottom: 0;
  }
  .concept-bar {
    padding: 6px 12px;
  }
  .scope-bar {
    font-size: 13px;
  }
  .map-heading {
    flex-wrap: wrap;
  }
  .map-heading > .button {
    min-height: 44px;
  }
  .search-toolbar .button {
    min-height: 44px;
  }
  .relationship-row {
    padding: 12px;
  }
  .evidence blockquote {
    padding: 16px;
  }
}
.map-content :is(button, a, input, select, summary) {
  scroll-margin-top: calc(var(--workspace-header-height, 0px) + 16px);
  scroll-margin-bottom: 16px;
}

@media (max-height: 700px) {
  .detail-pane {
    max-height: none;
    overflow: visible;
  }
  .relations-heading, .evidence-toolbar {
    position: static;
  }
  .relationship-list {
    max-height: none;
    overflow: visible;
  }
  .loading-workspace {
    min-height: 280px;
  }
  .loading-lines {
    height: 140px;
    margin-top: 20px;
  }
}
@media (pointer: coarse), (max-width: 760px) {
  .map-content :is(.button, .text-button, .text-link, .concept-trigger, .campaign-info summary, select) {
    min-height: 44px;
  }
  .map-content .icon-button {
    width: 44px;
    height: 44px;
  }
  .map-content .search-input input {
    min-height: 44px;
    font-size: 16px;
  }
  .map-content select {
    font-size: 16px;
  }
}
/* Connection recovery is distinct from a confirmed permission restriction. */
.bootstrap-recovery {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.bootstrap-recovery > span {
  flex: 1 1 240px;
  overflow-wrap: anywhere;
}

.bootstrap-recovery > .button {
  flex-shrink: 0;
}

/* The selected document and the recorded construction update remain explicit. */
.scope-bar .selected-source {
  min-width: 0;
  max-width: 100%;
  overflow-wrap: anywhere;
}

.campaign-updated {
  display: block;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid var(--map-line);
  font-size: 12px;
  font-variant-numeric: tabular-nums;
}

/* Selection changes color while the map geometry stays in its native coordinates. */
.graph-node.claim-selected > rect {
  stroke: var(--map-blue);
  stroke-width: 2.5;
}

.graph-edge.chosen .edge-label-bg {
  fill: var(--ui-selected);
}

.map-stage {
  position: relative;
}

.map-navigation-status {
  position: absolute;
  z-index: 4;
  inset: auto 16px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  width: fit-content;
  max-width: calc(100% - 32px);
  margin: 0 auto;
  padding: 9px 14px;
  border-radius: 8px;
  background: var(--ui-paper);
  color: var(--ui-text);
  font-size: 13px;
  line-height: 1.5;
  box-shadow: 0 6px 20px rgba(35, 39, 47, 0.0941176471);
  pointer-events: none;
}

.map-navigation-status .spinner {
  flex: none;
}

@media (prefers-reduced-motion: no-preference) {
  .map-filters, .concept-options {
    animation: map-controls-ready 180ms ease-out;
  }
  .concept-option, .relationship-row {
    transition: background-color var(--motion-fast, 120ms) var(--motion-ease, ease-out), color var(--motion-fast, 120ms) var(--motion-ease, ease-out);
  }
}
@keyframes map-controls-ready {
  from {
    opacity: 0.85;
  }
  to {
    opacity: 1;
  }
}
@media (prefers-reduced-motion: reduce) {
  .map-navigation-status .spinner {
    animation: none;
  }
}
/* One concept context, legible relationships, and an uninterrupted evidence view. */
.concept-bar {
  align-items: center;
  padding: 12px 16px;
}

.concept-browser {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 4px 10px;
  align-items: center;
}

.compact-concept-type {
  display: block;
  grid-column: 1;
  grid-row: 1;
  font-size: 13px;
  font-weight: 650;
}

.concept-trigger {
  grid-column: 2;
  grid-row: 1;
  min-width: 0;
  padding: 0;
}

.concept-trigger strong {
  font-size: 20px;
  white-space: normal;
  text-align: left;
  overflow-wrap: anywhere;
  line-height: 1.4;
}

.concept-trigger > span {
  display: none;
}

.compact-concept-source {
  display: block;
  grid-column: 1/-1;
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: var(--ui-muted);
  overflow-wrap: anywhere;
}

.concept-options {
  top: calc(100% + 8px);
}

.relations-heading {
  padding-bottom: 12px;
  border-bottom: 1px solid var(--map-line);
}

.relationship-row {
  border-bottom: 1px solid var(--map-line);
}

.relationship-row strong {
  font-size: 16px;
}

.relation-label {
  color: var(--ui-text);
}

.evidence blockquote {
  font-size: 17px;
}

.campaign-updated {
  font-size: 13px;
}

@media (max-width: 1249px) {
  .diagram-disclosure:not([open]) > summary span {
    display: none;
  }
  .diagram-disclosure > summary {
    padding: 12px 16px;
    font-size: 14px;
  }
}
@media (max-width: 760px) {
  .concept-bar {
    padding: 12px;
    gap: 8px;
  }
  .concept-trigger strong {
    font-size: 18px;
  }
  .compact-concept-type {
    margin: 0;
  }
  .concept-browser {
    flex-basis: 100%;
  }
  .has-evidence .exploration-controls .search-toolbar, .has-evidence .map-filters {
    display: none;
  }
  .has-evidence .exploration-controls {
    padding-block: 4px;
  }
  .evidence blockquote {
    font-size: 16px;
  }
}
/* Map: controls form one group; graph and relation list own their heights. */
:host, .map-content {
  background: transparent;
}

.map-content .map-heading {
  margin: 0 0 16px;
  align-items: center;
  min-height: 40px;
}

.map-content .exploration-controls {
  padding: 0;
  margin: 0;
  background: transparent;
}

.map-content .search-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0;
  padding: 12px 0;
  border: 0;
  border-bottom: 1px solid var(--ui-line);
  border-radius: 0;
  background: transparent;
}

.map-content .search-input {
  flex: 1 1 220px;
  min-width: 0;
}

.map-content .scope-bar {
  margin: 8px 0 0;
  padding: 0;
  color: var(--ui-text);
}

.map-content .concept-bar {
  padding: 16px 0;
  border-color: var(--ui-line);
  background: transparent;
}

.map-content .explorer {
  align-items: start;
}

.map-content .map-stage {
  display: flex;
  flex-direction: column;
  align-self: start;
  height: auto;
  min-height: 0;
}

.map-content .diagram-disclosure {
  flex: none;
  min-height: 0;
}

.map-content .diagram-footer {
  flex: none;
  min-height: 0;
  padding: 8px 18px;
  background: var(--ui-paper);
  color: var(--ui-muted);
}

.map-content .map-footnote {
  flex: none;
  height: auto;
  min-height: 0;
  padding: 12px 18px;
  margin: 0;
  background: var(--ui-paper);
}

.map-content .relations-heading {
  padding: 16px;
}

.map-content .relationship-row {
  padding-block: 14px;
  border-color: var(--ui-line);
}

.map-content .evidence-panel {
  border-color: var(--ui-line);
  background: var(--ui-paper);
  scroll-margin-top: calc(var(--workspace-header-height) + 16px);
}

@media (max-width: 700px) {
  .map-content .map-heading {
    gap: 8px;
    margin-bottom: 12px;
  }
  .map-content .search-toolbar {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 8px;
    padding-top: 0;
    padding-bottom: 12px;
  }
  .map-content .search-input {
    grid-column: 1;
    min-width: 0;
  }
  .map-content .search-toolbar > button[type=submit] {
    grid-column: 2;
  }
  .map-content .search-toolbar > button.secondary {
    grid-column: 1;
    justify-self: start;
  }
  .map-content .search-toolbar > .refresh-button {
    grid-column: 2;
    justify-self: end;
  }
  .map-content .concept-bar {
    padding: 12px 0;
  }
  .map-content .diagram-footer, .map-content .map-footnote {
    padding: 10px 14px;
  }
}
/* One connected exploration bench: search, concept, canvas and evidence. */
.map-content {
  font-size: 14px;
}
.map-content .map-heading h1 {
  font-size: 26px;
  line-height: 1.3;
  letter-spacing: -0.025em;
}
.map-content .map-heading {
  margin-bottom: 20px;
}
.map-content .campaign-info summary {
  font-size: 12px;
  color: var(--ui-muted);
}
.map-content .campaign-info p {
  border: 0;
  border-radius: 12px;
  box-shadow: var(--ui-overlay-shadow);
  background: var(--ui-paper);
  font-size: 13px;
}
.map-content .exploration-controls {
  padding: 16px 20px 12px;
  background: var(--ui-soft);
  border: 1px solid var(--ui-line);
  border-radius: 14px 14px 0 0;
  box-shadow: none;
}
.map-content .search-toolbar {
  padding: 0;
  border: 0;
  gap: 8px;
}
.map-content .search-input input {
  min-height: 38px;
  font-size: 14px;
  border-radius: 9px;
}
.map-content .search-toolbar .button, .map-content .refresh-button {
  height: 38px;
}
.map-content .scope-bar {
  margin-top: 8px;
  min-height: 30px;
  font-size: 12px;
  gap: 6px 14px;
}
.map-content .scope-bar .text-button {
  font-size: 12px;
  min-height: 30px;
}
.map-content .scope-bar .review-scope {
  color: var(--ui-text);
  font-weight: 550;
}
.map-content .scope-bar .selected-source {
  max-width: min(100%, 700px);
}
.map-content .map-filters {
  margin-top: 12px;
  padding: 14px;
  background: var(--ui-soft);
  border: 0;
  border-radius: 10px;
}
.map-content .map-filters label {
  font-size: 12px;
  font-weight: 550;
}
.map-content select {
  appearance: auto;
  border-radius: 9px;
  border-color: var(--ui-control);
}
.map-content .concept-bar {
  padding: 18px 20px;
  background: var(--ui-paper);
  border: 1px solid var(--ui-line);
  border-top: 0;
  gap: 12px;
}
.map-content .concept-browser {
  gap: 5px 10px;
}
.map-content .compact-concept-type {
  font-size: 12px;
}
.map-content .concept-trigger {
  min-height: 36px;
  border-radius: 7px;
}
.map-content .concept-trigger strong {
  font-size: 23px;
  font-weight: 650;
  letter-spacing: -0.02em;
}
.map-content .concept-trigger .concept-change-label {
  display: inline-flex;
  align-items: center;
  margin-left: 6px;
  padding: 3px 7px;
  border: 1px solid var(--ui-control);
  border-radius: 6px;
  color: var(--ui-text);
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}
.map-content .result-browse {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  margin-left: auto;
  flex: none;
}
.map-content .result-browse nav {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--ui-muted);
  font-size: 12px;
  font-variant-numeric: tabular-nums;
}
.map-content .result-browse .icon-button {
  min-width: 32px;
  min-height: 32px;
}
.map-content .concept-trigger i {
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background: var(--ui-chrome);
  color: var(--ui-text);
  flex: none;
}
.map-content .concept-trigger:hover i {
  background: var(--ui-selected);
  color: var(--ui-accent);
}
.map-content .compact-concept-source {
  font-size: 12px;
  color: var(--ui-muted);
}
.map-content .result-boundary {
  font-size: 12px;
  font-variant-numeric: tabular-nums;
}
.map-content .concept-options {
  border: 0;
  border-radius: 14px;
  box-shadow: var(--ui-overlay-shadow);
}
.map-content .concept-options header {
  padding: 10px 16px;
  background: var(--ui-soft);
}
.map-content .concept-options > p {
  padding: 10px 16px;
  font-size: 12px;
  color: var(--ui-muted);
}
.map-content .concept-option {
  padding: 12px 16px;
}
.map-content .concept-option strong {
  font-size: 14px;
}
.map-content .concept-option small {
  font-size: 12px;
}
.map-content .explorer {
  gap: 0;
  background: var(--ui-paper);
  border: 1px solid var(--ui-line);
  border-top: 0;
  border-radius: 0 0 14px 14px;
  overflow: hidden;
  grid-template-columns: minmax(0, 1fr) 320px;
}
.map-content .explorer.inspecting {
  grid-template-columns: minmax(0, 1fr) 380px;
}
.map-content .map-stage, .map-content .detail-pane {
  border: 0;
  border-radius: 0;
  background: var(--ui-paper);
  box-shadow: none;
  overflow: hidden;
}
.map-content .detail-pane {
  border-left: 1px solid var(--ui-line);
}
.map-content .map-stage {
  height: auto;
}
.map-content .diagram-toolbar {
  padding: 10px 16px;
  background: var(--ui-canvas);
  border-bottom: 1px solid var(--ui-line);
  font-size: 12px;
}
.map-content .zoom-tools {
  gap: 2px;
  padding: 2px;
  background: var(--ui-paper);
  border-radius: 8px;
}
.map-content .zoom-tools .text-button {
  min-width: 48px;
  font-size: 12px;
}
.map-content .zoom-tools .icon-button {
  border-radius: 6px;
  width: 32px;
  height: 32px;
}
.map-content .zoom-tools .icon-button:hover:not(:disabled) {
  background: var(--ui-selected);
}
.map-content .diagram-scroll {
  background: var(--ui-canvas);
}
.map-content .edge-label-bg {
  fill: var(--ui-canvas);
}
.map-content .edge-line {
  stroke: #7a9080;
}
.map-content .graph-edge.negative .edge-line {
  stroke: var(--ui-danger);
}
.map-content .graph-edge:is(.chosen, :hover, :focus-visible) .edge-line {
  stroke: var(--ui-accent);
}
.map-content .graph-edge.chosen .edge-label-bg {
  fill: var(--ui-selected);
}
.map-content .graph-node rect {
  rx: 12px;
}
.map-content .diagram-footer {
  padding: 8px 14px;
  border-top: 1px solid var(--ui-line);
  font-size: 12px;
}
.map-content .diagram-footer > div {
  gap: 8px;
}
.map-content .diagram-footer .icon-button {
  width: 32px;
  height: 32px;
  border-radius: 7px;
}
.map-content .map-footnote {
  padding: 7px 14px 12px;
  font-size: 12px;
  gap: 4px 7px;
}
.map-content .detail-pane {
  overflow: auto;
  scrollbar-gutter: stable;
}
.map-content .relations-heading {
  padding: 14px;
  background: var(--ui-soft);
  gap: 8px;
  border-bottom: 1px solid var(--ui-line);
}
.map-content .relations-heading h2 {
  font-size: 15px;
  font-weight: 650;
}
.map-content .relation-filter select {
  font-size: 12px;
}
.map-content .relationship-list {
  padding: 0;
}
.map-content .relationship-row {
  padding: 14px 16px;
  border: 0;
  border-bottom: 1px solid var(--ui-line);
  border-radius: 0;
  margin: 0;
  background: var(--ui-paper);
}
.map-content .relationship-row:hover, .map-content .relationship-row.chosen {
  background: var(--ui-selected);
}
.map-content .relationship-row strong {
  font-size: 15px;
  font-weight: 600;
}
.map-content .relation-label, .map-content .relation-source {
  font-size: 12px;
}
.map-content .evidence-toolbar {
  padding: 7px 14px;
  background: var(--ui-soft);
}
.map-content .evidence-toolbar > span {
  font-size: 12px;
}
.map-content .claim-summary {
  padding: 18px;
}
.map-content .claim-summary h2 {
  font-size: 22px;
  line-height: 1.5;
  font-weight: 650;
}
.map-content .claim-summary .concept-type {
  font-size: 13px;
}
.map-content .evidence {
  margin-inline: 18px;
  padding-block: 16px;
}
.map-content .evidence h3 {
  font-size: 14px;
  line-height: 1.65;
}
.map-content .evidence header p {
  font-size: 12px;
}
.map-content .evidence blockquote {
  background: var(--ui-soft);
  border-radius: 10px;
  padding: 16px;
  font-size: 16px;
  line-height: 1.85;
}
.map-content .evidence a, .map-content .review-link {
  font-size: 13px;
}
.map-content .review-link {
  margin: 0 18px 18px;
}
.map-content .query-footer {
  padding: 12px 2px;
  gap: 12px;
}
.map-content .query-footer p {
  font-size: 12px;
}
.map-content .query-footer .button {
  font-size: 13px;
}
.map-content .query-footer > div {
  gap: 10px;
  font-size: 12px;
}
.map-content .loading-workspace, .map-content .empty {
  margin-top: 0;
  border: 1px solid var(--ui-line);
  border-top: 0;
  border-radius: 0 0 14px 14px;
  background: var(--ui-paper);
  box-shadow: none;
}
.map-content .error-message {
  border-radius: 10px;
  font-size: 14px;
}
.map-content .icon-button {
  border-radius: 9px;
}

@media (max-width: 1249px) {
  .map-content .explorer, .map-content .explorer.inspecting {
    grid-template-columns: minmax(0, 1fr);
  }
  .map-content .detail-pane {
    overflow: visible;
    border-left: 0;
    border-top: 1px solid var(--ui-line);
  }
  .map-content .diagram-disclosure > summary {
    padding: 14px 16px;
    background: var(--ui-soft);
    border: 0;
    font-size: 14px;
    color: var(--ui-ink);
  }
  .map-content .diagram-disclosure[open] > summary {
    border-bottom: 1px solid var(--ui-line);
  }
  .map-content .relationship-row:nth-child(odd) {
    border-right: 0;
  }
  .map-content .evidence-panel {
    border-radius: 0;
    overflow: clip;
  }
  .map-content .evidence-toolbar {
    position: static;
  }
}
@media (max-width: 760px) {
  .map-content .map-heading {
    margin-bottom: 16px;
  }
  .map-content .map-heading h1 {
    font-size: 24px;
  }
  .map-content .exploration-controls {
    padding: 12px;
  }
  .map-content .search-toolbar {
    padding: 0;
  }
  .map-content .search-input input, .map-content select {
    font-size: 16px;
    min-height: 44px;
  }
  .map-content .search-toolbar .button, .map-content .refresh-button {
    height: 44px;
  }
  .map-content .map-filters {
    padding: 12px;
  }
  .map-content .concept-bar {
    padding: 14px 12px;
  }
  .map-content .result-browse {
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .map-content .result-browse .icon-button {
    min-width: 44px;
    min-height: 44px;
  }
  .map-content .concept-trigger {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .map-content .concept-trigger .concept-change-label {
    font-size: 12px;
  }
  .map-content .concept-trigger strong {
    font-size: 19px;
  }
  .map-content .concept-trigger {
    min-height: 44px;
  }
  .map-content .result-boundary {
    width: auto;
    min-width: 0;
    flex: 1;
    font-size: 12px;
  }
  .map-content .result-browse nav {
    flex: none;
  }
  .map-content .relations-heading {
    padding: 12px;
  }
  .map-content .relation-filter select {
    font-size: 16px;
  }
  .map-content .relationship-list {
    padding: 0;
  }
  .map-content .relationship-row {
    padding: 14px 12px;
  }
  .map-content .claim-summary {
    padding: 16px;
  }
  .map-content .claim-summary h2 {
    font-size: 21px;
  }
  .map-content .evidence {
    margin-inline: 16px;
  }
  .map-content .evidence blockquote {
    padding: 14px;
  }
  .map-content .review-link {
    margin-inline: 16px;
  }
  .map-content .query-footer > div {
    gap: 8px;
  }
  .map-content .query-footer .button {
    flex: 1;
    padding-inline: 10px;
    white-space: normal;
  }
  .map-content .zoom-tools .icon-button, .map-content .diagram-footer .icon-button {
    width: 44px;
    height: 44px;
  }
  .map-content.has-evidence .exploration-controls {
    padding-block: 5px;
  }
  .map-content.has-evidence .search-toolbar {
    display: none;
  }
}
@media (hover: hover) and (prefers-reduced-motion: no-preference) {
  .map-content :is(.concept-trigger i, .relationship-row, .concept-option, .zoom-tools .icon-button) {
    transition: background-color var(--ui-duration, 180ms) var(--ui-ease, ease-out), color var(--ui-duration, 180ms) var(--ui-ease, ease-out);
  }
}
@media (prefers-reduced-motion: reduce) {
  .map-content :is(.concept-trigger i, .relationship-row, .concept-option, .zoom-tools .icon-button) {
    transition: none;
  }
}
@media (pointer: coarse) {
  .map-content .search-toolbar .button {
    min-height: 44px;
  }
  .map-content .search-input input, .map-content select {
    min-height: 44px;
    font-size: 16px;
  }
  .map-content .zoom-tools .icon-button, .map-content .diagram-footer .icon-button, .map-content .refresh-button {
    width: 44px;
    height: 44px;
  }
}
/* Keep review, exploration and execution inside one knowledge workspace. */
.knowledge-sections {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  margin: 0 0 20px;
  padding: 4px;
  border: 1px solid var(--ui-line);
  border-radius: 10px;
  background: var(--ui-soft);
}

.knowledge-sections > a, .knowledge-sections > button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 9px 16px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--ui-text);
  font: inherit;
  font-size: 14px;
  font-weight: 550;
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
}

.knowledge-sections > .active {
  background: var(--ui-accent);
  color: var(--ui-on-navy);
  font-weight: 650;
}

.knowledge-sections > :hover:not(.active):not(:disabled) {
  background: var(--ui-selected);
}

.knowledge-sections > :focus-visible {
  outline: 2px solid var(--ui-accent);
  outline-offset: 2px;
}

.knowledge-sections > :disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

@media (max-width: 600px) {
  .knowledge-sections {
    gap: 3px;
    margin-bottom: 16px;
  }
  .knowledge-sections > a, .knowledge-sections > button {
    flex: 1;
    min-height: 44px;
    padding: 8px 10px;
    font-size: 13px;
  }
}
.map-content .relation-filter select {
  min-width: 152px;
  max-width: 200px;
}`],
})
export class PageKnowledge_mapComponent implements OnInit, OnDestroy {
    workspacePage='지식 관리'; user:any; csrf=''; loading=true; graphLoading=false; itemLoading=false;
    error=''; itemError=''; bootstrapError=''; sessionReady=false; private bootstrapping=false; sources:any[]=[]; campaign:any=null;
    conceptsOpen=false; filtersOpen=false; collection=''; source='0'; type=''; query=''; scope='ai';
    focusId=''; focusName=''; anchorId=''; relationType=''; edgePage=0;
    selected:any=null; activeCandidate=0; compact=window.innerWidth<1250;
    data:any={nodes:[],edges:[],items:[],has_more:false};
    nodes:any[]=[]; edges:any[]=[]; connected:any[]=[]; history:any[]=[];
    zoom=1; panX=0; panY=0; offsets:number[]=[0]; offsetIndex=0;
    private epoch=0; private itemEpoch=0; private alive=true; private drag:any=null; private returnFocus:any=null;
    private evidenceReturn:any=null;
    focusLoading=false;
    private media=window.matchMedia('(max-width:1249px)');
    private resize=()=>{this.compact=this.media.matches;this.service.render();};
    @ViewChild('inspector') inspector!:ElementRef<HTMLElement>;
    readonly types:any={"CONDITION":"질환·병증 · 이전 추출","SYMPTOM":"증상 · 이전 추출","FORMULA":"처방 · 이전 추출","HERB":"본초 · 이전 추출","ACUPOINT":"경혈 · 이전 추출","MERIDIAN_REF":"경락 참조 · 이전 추출","Herb":"본초","Formula / Protocol":"처방·복합 요법","Acupoint":"경혈·경락","TKM_Concept / Theory":"한의 개념·이론","Compound":"화합물","Gene / Variant":"유전자·변이","Pathway":"생물학적 경로","Biomarker":"생체 지표","Cell Type & Receptor":"세포·수용체","Biological Process":"생물학적 과정","Disease":"질환","Pattern":"병증·변증","Symptom / Phenotype":"증상·표현형","Constitution":"체질","Severity & Stage":"중증도·단계","Intervention":"치료·중재","Modern_Medication":"현대 의약품","Diagnostic_Device / Alg":"진단 기기·알고리즘","Assessment & Observation":"평가·관찰","Source_Text":"출처 문헌","Historical_Figure":"의가·역사 인물"};
    readonly relations:any={"HAS_SYMPTOM":"증상","INDICATED_FOR":"주치","CONTAINS_HERB":"구성 본초","RELATED_TO":"관련","MERIDIAN":"본초 귀경","CO_ADMINISTERED_WITH":"병용","PAIRED_WITH":"배합","TREATS":"치료","PREVENTS":"예방","SYNERGIZES_WITH":"상승효과","MODULATES":"조절","HAS_OUTCOME":"관찰 결과","UPREGULATES":"상향 조절","ACTIVATES":"활성화","DOWNREGULATES":"하향 조절","INHIBITS":"억제","CAUSES":"원인","INDUCES":"유발","INTERACTS_WITH_NEGATIVELY":"유해 상호작용","CAUSES_ADVERSE_EVENT":"이상 반응 유발","CONTRAINDICATED_IN":"금기","DIAGNOSES":"진단","EXCLUDES":"진단 배제","IS_MANDATORY_FOR":"필수 진단 조건","REQUIRES_ALL":"모든 조건 필요","MEASURES":"측정","HAS_CRITERION":"진단 기준","PATTERN_OF":"질환의 변증","COMORBID_WITH":"동반 질환","HAS_TRAIT":"고유 특성","HAS_INGREDIENT":"구성 성분","USES_ACUPOINT":"사용 경혈","BELONGS_TO_MERIDIAN":"경혈 소속 경락","ASSOCIATED_WITH":"연관","BIOMARKER_OF":"생체 지표 관계","MARKER_OF":"특징 지표","INVOLVES_PROCESS":"연관 과정","SUBTYPE_OF":"하위 유형","CLASSIFIES_INTO":"분류","PROGRESSES_TO":"진행","DESCRIBED_IN":"문헌 수록","ORIGINATES_FROM":"기원"};
    readonly colors:any={"CONDITION":"#28634d","SYMPTOM":"#874e16","FORMULA":"#006ca8","HERB":"#45662b","ACUPOINT":"#69489c","MERIDIAN_REF":"#8a4664","Herb":"#45662b","Formula / Protocol":"#006ca8","Acupoint":"#69489c","TKM_Concept / Theory":"#8a4664","Compound":"#45662b","Gene / Variant":"#006ca8","Pathway":"#006ca8","Biomarker":"#006ca8","Cell Type & Receptor":"#006ca8","Biological Process":"#006ca8","Disease":"#28634d","Pattern":"#28634d","Symptom / Phenotype":"#874e16","Constitution":"#28634d","Severity & Stage":"#28634d","Intervention":"#69489c","Modern_Medication":"#45662b","Diagnostic_Device / Alg":"#69489c","Assessment & Observation":"#874e16","Source_Text":"#8a4664","Historical_Figure":"#8a4664"};
    readonly fills:any={"CONDITION":"#eef6f1","SYMPTOM":"#fcf4e9","FORMULA":"#eaf4fb","HERB":"#f2f6eb","ACUPOINT":"#f3eff9","MERIDIAN_REF":"#faf0f4","Herb":"#f2f6eb","Formula / Protocol":"#eaf4fb","Acupoint":"#f3eff9","TKM_Concept / Theory":"#faf0f4","Compound":"#f2f6eb","Gene / Variant":"#eaf4fb","Pathway":"#eaf4fb","Biomarker":"#eaf4fb","Cell Type & Receptor":"#eaf4fb","Biological Process":"#eaf4fb","Disease":"#eef6f1","Pattern":"#eef6f1","Symptom / Phenotype":"#fcf4e9","Constitution":"#eef6f1","Severity & Stage":"#eef6f1","Intervention":"#f3eff9","Modern_Medication":"#f2f6eb","Diagnostic_Device / Alg":"#f3eff9","Assessment & Observation":"#fcf4e9","Source_Text":"#faf0f4","Historical_Figure":"#faf0f4"};
    private initialSession:any=null;
    constructor(@Inject(Service) public service:Service,@Inject(ActivatedRoute) private route:ActivatedRoute) {
        const session=this.route?.snapshot?.data?.['workspace']?.session;
        if(session?.code===200 && session.data?.user){this.initialSession=session;this.user=session.data.user;this.csrf=session.data.csrf;}
    }
    get canRead(){return this.user?.status==='active' && ['admin','researcher'].includes(this.user?.role);}
    get typeOptions(){return Object.keys(this.types);}
    get visibleSources(){return this.sources.filter(s=>!this.collection || s.collection===this.collection);}
    get selectedSourceName(){return this.sources.find(s=>String(s.source_document_id)===String(this.source))?.title || '선택 문헌 정보 없음';}
    get campaignUpdatedAt(){const value=this.campaign?.updated_at;if(!value)return null;const date=new Date(value);return Number.isFinite(date.getTime())?date:null;}
    get activeFilters(){return [this.collection,this.source!=='0'?this.source:'',this.type,this.scope==='expert'?'expert':''].filter(Boolean).length;}
    get anchor(){return this.data.nodes.find((n:any)=>n.id===this.anchorId);}
    get choices(){
        const query=this.query.trim().toLocaleLowerCase();
        return [...this.data.nodes].sort((a:any,b:any)=>{
            const score=(n:any)=>Number(!!query&&n.name.toLocaleLowerCase()===query)*10000+Number(!!query&&n.name.toLocaleLowerCase().includes(query))*1000+this.data.edges.filter((e:any)=>e.source===n.id||e.target===n.id).length;
            return score(b)-score(a)||a.name.localeCompare(b.name,'ko');
        });
    }
    get relationOptions(){return [...new Set(this.connected.map(e=>e.type))] as string[];}
    get filteredConnections(){return this.connected.filter(e=>!this.relationType||e.type===this.relationType);}
    get isolatedItems(){return this.connected.length?[]:this.data.items.filter((i:any)=>i.kind==='concept'&&i.job_id===this.anchor?.job_id&&i.name===this.anchor?.name);}
    get diagramPages(){return Math.max(1,Math.ceil(this.filteredConnections.length/6));}
    get diagramRange(){return this.filteredConnections.length ? (this.edgePage*6+1)+'–'+Math.min((this.edgePage+1)*6,this.filteredConnections.length):'0';}
    get scopeLabel(){return this.scope==='ai'?'AI 검수 · 전문가 미승인':'전문가 승인';}
    get campaignLabel(){return {RUNNING:'구축 진행 중',PAUSED:'구축 일시정지',PAUSED_AFTER_LIMIT:'구축 일시정지',NEEDS_ATTENTION:'구축 확인 필요',COMPLETED:'전량 처리 완료',COMPLETED_WITH_FINDINGS:'전량 처리 완료 · 보류 있음'}[this.campaign?.status] || '구축 준비 중';}
    async ngOnInit(){
        await this.service.init();if(!this.alive)return;document.title='관계 지도 · 지식 관리 · 한의문헌 저작도구';this.media.addEventListener('change',this.resize);
        await this.bootstrap();
    }
    async bootstrap(){
        if(!this.alive || this.bootstrapping)return;
        this.bootstrapping=true;this.loading=true;this.bootstrapError='';await this.service.render();
        try{
            const b=this.initialSession || await wiz.app('page.access').call('bootstrap',{}, {timeout:10000});
            this.initialSession=null;
            if(!this.alive)return;
            if(b.code===401 || (b.code===200 && !b.data?.user)){this.service.href('/access/login');return;}
            if(b.code!==200)throw new Error('bootstrap');
            this.user=b.data.user;this.csrf=b.data.csrf;this.sessionReady=true;
            if(this.canRead)await this.refresh();
        }catch{
            if(this.alive){this.sessionReady=false;this.bootstrapError='계정 정보를 불러오지 못했습니다. 연결을 확인한 뒤 다시 시도해 주세요.';}
        }finally{this.bootstrapping=false;this.loading=false;if(this.alive)await this.service.render();}
    }
    ngOnDestroy(){this.alive=false;this.epoch++;this.itemEpoch++;this.media.removeEventListener('change',this.resize);}
    async call(action:string,values:any={}){
        try{
            const r=await wiz.app('page.knowledge_graph').call(action,values,{timeout:45000});
            if(!this.alive)throw new Error('화면을 닫아 조회를 중단했습니다.');
            if(r.code===401)this.service.href('/access/login');
            if(r.code!==200)throw new Error(r.data?.message||'자료를 불러오지 못했습니다. 다시 시도해 주세요.');
            return r.data;
        }catch(value:any){
            throw new Error(value?.message || '자료를 불러오지 못했습니다. 연결을 확인하고 다시 시도해 주세요.');
        }
    }
    async refresh(){
        this.error='';
        try{const c=await this.call('explore_catalog');if(!this.alive)return;this.sources=c.sources;this.campaign=c.campaign;await this.search();}
        catch(e:any){if(this.alive)this.error=e.message;}
        finally{if(this.alive)await this.service.render();}
    }
    toggleConcepts(){this.conceptsOpen=!this.conceptsOpen;this.service.render();}
    toggleFilters(){this.filtersOpen=!this.filtersOpen;this.service.render();}
    async search(){this.history=[];this.focusId='';this.focusName='';this.anchorId='';this.offsets=[0];this.offsetIndex=0;await this.load();}
    async changeCollection(){this.source='0';await this.search();}
    async clear(){this.collection='';this.source='0';this.type='';this.query='';await this.search();}
    async useAi(){this.scope='ai';await this.search();}
    snapshot(){return {data:this.data,focusId:this.focusId,focusName:this.focusName,anchorId:this.anchorId,offsets:[...this.offsets],offsetIndex:this.offsetIndex,relationType:this.relationType,edgePage:this.edgePage};}
    async focus(n:any){
        if(!n||this.graphLoading)return;
        this.history.push(this.snapshot());this.focusId=n.id;this.focusName=n.name;
        this.offsets=[0];this.offsetIndex=0;await this.load(true);
    }
    async choose(id:string){this.conceptsOpen=false;await this.focus(this.data.nodes.find((n:any)=>n.id===id));}
    async back(){
        const previous=this.history.pop();if(!previous)return;
        this.focusLoading=false;
        this.epoch++;this.itemEpoch++;Object.assign(this,previous);this.graphLoading=false;this.selected=null;this.itemLoading=false;this.itemError='';this.error='';
        this.prepare(false);await this.service.render();
    }
    async next(){if(!this.data.has_more||this.graphLoading)return;this.offsets=this.offsets.slice(0,this.offsetIndex+1);this.offsets.push(this.data.next_offset);this.offsetIndex++;await this.load();}
    async previous(){if(this.offsetIndex&&!this.graphLoading){this.offsetIndex--;await this.load();}}
    async load(retainGraph=false){
        // Retain the current map during focus loading without delaying the response.
        this.focusLoading=retainGraph&&!!this.data.items.length;
        this.conceptsOpen=false;
        const ticket=++this.epoch;this.itemEpoch++;this.selected=null;this.activeCandidate=0;this.itemError='';this.itemLoading=false;this.error='';this.graphLoading=true;await this.service.render();
        try{
            const g=await this.call('explore',{q:this.focusId?'':this.query,source:this.source,collection:this.collection,type:this.type,node:this.focusId,scope:this.scope,offset:this.offsets[this.offsetIndex]});
            if(!this.alive||ticket!==this.epoch)return;
            this.data=g;this.anchorId=g.nodes.some((n:any)=>n.id===this.focusId)?this.focusId:(this.choices[0]?.id||'');this.prepare();
        }catch(e:any){if(ticket===this.epoch){this.error=e.message;this.data={nodes:[],edges:[],items:[],has_more:false};this.nodes=[];this.edges=[];this.connected=[];}}
        finally{if(this.alive&&ticket===this.epoch){this.graphLoading=false;this.focusLoading=false;await this.service.render();}}
    }
    prepare(reset=true){
        if(reset){this.relationType='';this.edgePage=0;}
        this.connected=this.data.edges.filter((e:any)=>e.source===this.anchorId||e.target===this.anchorId).map((e:any)=>({...e,sourceName:this.nodeName(e.source),targetName:this.nodeName(e.target)}));
        this.layout();this.fit();
    }
    sourceName(n:any){return this.data.items.find((i:any)=>i.job_id===n?.job_id)?.source_title||n?.job_name||'';}
    nodeName(id:string){return this.data.nodes.find((n:any)=>n.id===id)?.name||'';}
    changeRelation(){this.edgePage=0;this.selected=null;this.itemEpoch++;this.itemLoading=false;this.itemError='';this.layout();this.fit();this.service.render();}
    diagramPage(delta:number){this.edgePage=Math.max(0,Math.min(this.diagramPages-1,this.edgePage+delta));this.layout();this.fit();this.service.render();}
    // A bounded, labelled fan keeps six source claims legible without merging identities.
    layout(){
        const center=this.anchor;if(!center){this.nodes=[];this.edges=[];return;}
        const subset=this.filteredConnections.slice(this.edgePage*6,this.edgePage*6+6);
        const count=subset.length;const centerNode={...center,x:160,y:250,center:true,lines:this.wrapName(center.name,210)};
        this.nodes=[centerNode];this.edges=[];
        subset.forEach((e:any,i:number)=>{
            const other=this.data.nodes.find((n:any)=>n.id===(e.source===center.id?e.target:e.source));
            const y=count===1?250:55+i*(390/(count-1));const target={...other,x:655,y,center:false,lines:this.wrapName(other?.name||'',220),claimId:e.candidate_id};
            // Repeated claims remain separate rows, even when their endpoint ID is identical.
            this.nodes.push(target);
            const forward=e.source===center.id;
            const x1=forward?280:535,x2=forward?535:280,y1=forward?250:y,y2=forward?y:250;
            this.edges.push({...e,label:this.relations[e.type],labelX:414,labelY:250+(y-250)*.6,path:'M '+x1+' '+y1+' C 392 '+y1+', 434 '+y2+', '+x2+' '+y2});
        });
    }

    trackEdge(_index:number,edge:any){return this.anchorId+':'+edge.candidate_id;}
    trackNode(_index:number,node:any){return node.center?'center:'+node.id:'claim:'+node.claimId+':'+node.id;}
    wrapName(name:string,width:number){
        const canvas=document.createElement('canvas'),ctx=canvas.getContext('2d')!;ctx.font='700 19px Pretendard, sans-serif';
        const units=name.match(/\([^)]*\)|[^()\s]+|\s+/g)||[name];let lines:string[]=[],line='';
        for(const unit of units){
            if(ctx.measureText(line+unit).width<=width){line+=unit;continue;}
            if(line.trim()){lines.push(line.trim());line='';}
            if(ctx.measureText(unit).width<=width){line=unit;continue;}
            for(const char of Array.from(unit)){if(ctx.measureText(line+char).width>width){lines.push(line);line='';}line+=char;}
        }
        if(line.trim())lines.push(line.trim());if(lines.length>2){let last=lines[1];while(ctx.measureText(last+'…').width>width)last=last.slice(0,-1);lines=[lines[0],last+'…'];}
        return lines;
    }
    fit(){this.zoom=1;this.panX=0;this.panY=0;this.service.render();}
    zoomBy(factor:number){const z=Math.max(.65,Math.min(2.5,this.zoom*factor)),f=z/this.zoom;this.panX=410-(410-this.panX)*f;this.panY=250-(250-this.panY)*f;this.zoom=z;this.service.render();}
    beginPan(e:PointerEvent){if((e.target as Element).closest('[data-node],[data-edge]')||e.button!==0)return;this.drag={id:e.pointerId,x:e.clientX,y:e.clientY,px:this.panX,py:this.panY,scale:820/(e.currentTarget as Element).getBoundingClientRect().width};(e.currentTarget as Element).setPointerCapture(e.pointerId);}
    movePan(e:PointerEvent){if(!this.drag||this.drag.id!==e.pointerId)return;this.panX=this.drag.px+(e.clientX-this.drag.x)*this.drag.scale;this.panY=this.drag.py+(e.clientY-this.drag.y)*this.drag.scale;this.service.render();}
    endPan(){this.drag=null;}
    assertion(v:string){return {positive:'긍정',uncertain:'조건부·불확실',negative:'부정'}[v]||'';}
    async inspect(item:any,event?:Event){
        if(this.graphLoading)return;
        if(!this.selected&&!this.itemLoading&&!this.itemError)this.evidenceReturn={
            pane:document.querySelector('.detail-pane')?.scrollTop||0,
            list:document.querySelector('.relationship-list')?.scrollTop||0,
            x:window.scrollX,y:window.scrollY
        };
        const ticket=++this.itemEpoch;this.returnFocus=event?.currentTarget;this.activeCandidate=item.candidate_id;
        const idx=this.filteredConnections.findIndex(e=>e.candidate_id===item.candidate_id);
        if(idx>=0){this.edgePage=Math.floor(idx/6);this.layout();}
        this.selected=null;this.itemLoading=true;this.itemError='';await this.service.render();
        try{
            const value=await this.call('item',{id:item.job_id,candidate_id:item.candidate_id});
            if(!this.alive||ticket!==this.itemEpoch)return;
            if(value.changed||value.sync_pending||value.review_status!==(this.scope==='ai'?'AI_REVIEWED':'APPROVED'))throw new Error('검수 또는 원문 상태가 변경되었습니다. 지도를 새로고침해 주세요.');
            this.selected={...value,job_id:item.job_id,candidate_id:item.candidate_id};
        }catch(e:any){if(ticket===this.itemEpoch)this.itemError=e.message;}
        finally{if(this.alive&&ticket===this.itemEpoch){this.itemLoading=false;await this.service.render();const pane=document.querySelector('.detail-pane');if(pane)pane.scrollTop=0;this.inspector?.nativeElement.focus({preventScroll:true});if(this.compact)this.inspector?.nativeElement.scrollIntoView({block:'start'});}}
    }
    async close(){
        this.itemEpoch++;this.selected=null;this.itemError='';this.itemLoading=false;await this.service.render();
        const saved=this.evidenceReturn;this.evidenceReturn=null;
        if(saved){
            const pane=document.querySelector('.detail-pane'),list=document.querySelector('.relationship-list');
            if(pane)pane.scrollTop=saved.pane;if(list)list.scrollTop=saved.list;
            window.scrollTo(saved.x,saved.y);
        }
        if(this.returnFocus?.isConnected)this.returnFocus.focus({preventScroll:true});else document.querySelector<HTMLElement>('[data-claim="'+this.activeCandidate+'"]')?.focus({preventScroll:true});
    }
    evidenceTarget(e:any){return this.selected?.evidence_targets?.[e.content_unit_id];}
    evidencePdf(e:any){const target=this.evidenceTarget(e);return '/wiz/api/page.sources/pdf?path='+encodeURIComponent(target?.path || e.path)+'&page='+encodeURIComponent(target?.page || e.page);}
    evidenceParams(e:any){const target=this.evidenceTarget(e),path=target?.path || e.path;return {path:path.split('/').slice(0,-1).join('/'),result:path,pdf_page:target?.page || e.page,job:target?.job};}
}

export default PageKnowledge_mapComponent;